import React/*, {useState}*/ from 'react';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';

import {/*useracc,*/ postApi} from '../../../utils/functions';

import './emojis.css';

export default class Emojis extends React.Component {
  static contextType = UserContext;
  constructor(props) {
		super(props);
    this.state = {
			showIcons: this.props.showIcons,
			extendIcons: false,
			extendIconsShow: false,

			emojis: [],
			lastEmoji: 0,

			emojiGrid: [],

			ChatLiveEmoji: null,

    };
  };

	async componentDidMount() {

		//---- Incoming Emojis
		const ChatLiveEmoji = EventEmitter.addListener('/chatlive/emoji', async data => {
			//console.log(data);
			if( data.channel === this.props.channel ) {
				this.handleEmoji(data);
			}
		}); this.setState({ChatLiveEmoji});

		//const user = this.context;
		//console.log(user.user.user);


		let array1 = [50];
		let array2 = [25,75];
		let array3 = [15,35,65,75];
		let array4 = [10,20,30,40,60,70,80,90];
		let array5 = [5,45,55,95];

		for( let i = array2.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [array2[i], array2[j]] = [array2[j], array2[i]]; }
		for( let i = array3.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [array3[i], array3[j]] = [array3[j], array3[i]]; }
		for( let i = array4.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [array4[i], array4[j]] = [array4[j], array4[i]]; }
		for( let i = array5.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [array5[i], array5[j]] = [array5[j], array5[i]]; }
		array1 = [...array1, ...array2, ...array3, ...array4, ...array5];

		let emojiGrid = [];
		for( let i = 0; i < array1.length; i++ ) emojiGrid.push({left: array1[i], uid: 0, avatar: ''});
		this.setState({emojiGrid});

	}

	componentWillUnmount() {
		if( this.state.ChatLiveEmoji ) this.state.ChatLiveEmoji.remove();
	}

	extendMore(extend) {
		if( extend ) {
			this.setState({extendIcons: true, extendIconsShow:true});
		} else {
			this.setState({extendIcons:false, extendIconsShow:false});
		}
	}

	doEmoji(emoji) {
		window.getSelection().removeAllRanges();

		const _date = Date.now();
		if( this.state.lastEmoji > _date - 500 ) return;
		let emojis = this.state.emojis;
		emojis.push({
			left: 50,
			rotation: Math.floor(Math.random() * 3),
			emoji: emoji,
			ctime: Math.floor(Date.now()/1000),
		});
		this.setState({emojis, lastEmoji: _date});

		var params = new URLSearchParams();
		params.append('emoji', emoji);
		params.append('channel', this.props.channel)
		postApi('/api/v2/livechat/emoji', params);
		

		/*---- several properties
			left position - 50% as current user
			rotation angle
			emoji icon
			time
		*/

		/*---- Grid positions
			0 - 50%
			1 - 25%
			2 - 75%
			3 ...
		*/

	}

	async handleEmoji(data) {
		//---- Ignore emojis sent by the current user
		const user = this.context;
		if( data.uid === user.user.user.id ) return;
		//console.log(data);

		//---- Find user in grid
		/*let pos = 0;
		let grid = {...this.state.emojiGrid};
		for( let i = 0; i < grid.length; i++ ) {
			if( grid[i].uid === data.uid ) pos = i;
		}*/
		let pos = this.state.emojiGrid[await this.findUser( data.uid, data.avatar )];
		//console.log(pos);

		let emojis = this.state.emojis;
		emojis.push({
			left: pos.left,
			rotation: Math.floor(Math.random() * 3),
			emoji: data.emoji,
			ctime: Math.floor(Date.now()/1000),
			avatar: data.avatar,
		});
		this.setState({emojis});

		

	}
	findUser(uid, avatar){
		return new Promise((resolve, reject) => {
			//---- Find user in grid
			let grid = this.state.emojiGrid;
			for( let i = 0; i < grid.length; i++ ) {
				if( grid[i].uid === uid ) {
					resolve(i);
					return;
				}
			}
			for( let i = 1; i < grid.length; i++ ) {
				if( grid[i].uid === 0 ) {
					grid[i].uid = uid;
					grid[i].avatar = avatar;
					this.setState({emojiGrid: grid},()=>{
						resolve(i);
					});
					return;
				}
			}
		});
	}
	
	render() {
		const user = this.context;
		//console.log(this.state.select.select);
		const emojis = 
      Object.keys(this.state.emojis).map((e,i) => {
        return (
					<React.Fragment key={i}>
						{this.state.emojis[e].left !== 50 &&
							<>
								
								<img className="singleEmojiavatar" src={`https://mix365.co.uk${this.state.emojis[e].avatar}`} style={{left: `${this.state.emojis[e].left}%`}} alt="Profile Avatar" />
							</>
						}
						
						<div className={`singleEmoji-${this.state.emojis[e].rotation}`} style={{left: `${this.state.emojis[e].left}%`}}>
							{this.state.emojis[e].emoji}
							
          	</div>
						
						
						
					</React.Fragment>
        )
      })
		return (
			<>
				{user.user.access?.verified&&
					<>
						{this.props.showIcons&&
							<div className={`liveEmojiIcons ${this.state.extendIcons?'liveEmojiIcons-extend':'liveEmojiIcons-shrink'}`} onMouseEnter={()=>this.extendMore(true)} onMouseLeave={()=>this.extendMore(false)}>
								<span style={{padding: 4, cursor: 'pointer'}} onClick={()=>this.doEmoji("🔥")}>
									🔥
								</span>
								{this.state.extendIconsShow===true&&
									<span className="">
										<span style={{padding: 4, cursor: 'pointer'}} onClick={()=>this.doEmoji("⚡")}>
											⚡
										</span>
										<span style={{padding: 4, cursor: 'pointer'}} onClick={()=>this.doEmoji("🚨")}>
											🚨
										</span>
										<span style={{padding: 4, cursor: 'pointer'}} onClick={()=>this.doEmoji("🔄")}>
											🔄
										</span>
										<span style={{padding: 4, cursor: 'pointer'}} onClick={()=>this.doEmoji("🙌")}>
											🙌
										</span>
										<span style={{padding: 4, cursor: 'pointer'}} onClick={()=>this.doEmoji("❤️")}>
											❤️
										</span>
									</span>
								}
							</div>
						}
					</>
				}
				<div>
					{emojis}
				</div>
			</>
		);
	}
}	

